import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TitlebarBelowImageList from './TitlebarBelowImageList';
import ClientProvider from './client';
export default createDemo(import.meta.url, TitlebarBelowImageList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/image-list/demos/titlebar-below/TitlebarBelowImageList.tsx",
    "fileName": "TitlebarBelowImageList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import ImageList from '@mui/material/ImageList';\nimport ImageListItem from '@mui/material/ImageListItem';\nimport ImageListItemBar from '@mui/material/ImageListItemBar';\n\nexport default function TitlebarBelowImageList() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ImageList sx={{ width: 500, height: 450 }}>\n      {itemData.map((item) => (\n        <ImageListItem key={item.img}>\n          <img\n            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}\n            src={`${item.img}?w=248&fit=crop&auto=format`}\n            alt={item.title}\n            loading=\"lazy\"\n          />\n          <ImageListItemBar\n            title={item.title}\n            subtitle={<span>by: {item.author}</span>}\n            position=\"below\"\n          />\n        </ImageListItem>\n      ))}\n    </ImageList>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n\nconst itemData = [\n  {\n    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',\n    title: 'Breakfast',\n    author: '@bkristastucchio',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',\n    title: 'Burger',\n    author: '@rollelflex_graphy726',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',\n    title: 'Camera',\n    author: '@helloimnik',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',\n    title: 'Coffee',\n    author: '@nolanissac',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',\n    title: 'Hats',\n    author: '@hjrc33',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',\n    title: 'Honey',\n    author: '@arwinneil',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',\n    title: 'Basketball',\n    author: '@tjdragotta',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',\n    title: 'Fern',\n    author: '@katie_wasserman',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',\n    title: 'Mushrooms',\n    author: '@silverdalex',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',\n    title: 'Tomato basil',\n    author: '@shelleypauls',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',\n    title: 'Sea star',\n    author: '@peterlaster',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',\n    title: 'Bike',\n    author: '@southside_customs',\n  },\n];\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 88,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import ImageList from '@mui/material/ImageList';\nimport ImageListItem from '@mui/material/ImageListItem';\nimport ImageListItemBar from '@mui/material/ImageListItemBar';\n\nexport default function TitlebarBelowImageList() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ImageList sx={{ width: 500, height: 450 }}>\n      {itemData.map((item) => (\n        <ImageListItem key={item.img}>\n          <img\n            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}\n            src={`${item.img}?w=248&fit=crop&auto=format`}\n            alt={item.title}\n            loading=\"lazy\"\n          />\n          <ImageListItemBar\n            title={item.title}\n            subtitle={<span>by: {item.author}</span>}\n            position=\"below\"\n          />\n        </ImageListItem>\n      ))}\n    </ImageList>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n\nconst itemData = [\n  {\n    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',\n    title: 'Breakfast',\n    author: '@bkristastucchio',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',\n    title: 'Burger',\n    author: '@rollelflex_graphy726',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',\n    title: 'Camera',\n    author: '@helloimnik',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',\n    title: 'Coffee',\n    author: '@nolanissac',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',\n    title: 'Hats',\n    author: '@hjrc33',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',\n    title: 'Honey',\n    author: '@arwinneil',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',\n    title: 'Basketball',\n    author: '@tjdragotta',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',\n    title: 'Fern',\n    author: '@katie_wasserman',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',\n    title: 'Mushrooms',\n    author: '@silverdalex',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',\n    title: 'Tomato basil',\n    author: '@shelleypauls',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',\n    title: 'Sea star',\n    author: '@peterlaster',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',\n    title: 'Bike',\n    author: '@southside_customs',\n  },\n];\n"
      ]
    ],
    "totalLines": 88,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/ImageList",
      "@mui/material/ImageListItem",
      "@mui/material/ImageListItemBar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
